import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import type { DashboardPeriod } from './finance.api'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_DASHBOARD')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export interface SchedulingPerformanceQueryParams {
  clinicId: string
  date: string
  period: DashboardPeriod
}

export interface SchedulingPerformanceKpis {
  scheduledAppointments: string
  scheduledPatients: string
  scheduledProduction: string
  brokenAppointments: string
  noShow: string
  rescheduleRate: string
  scheduleUtilization: string
  openHours: string
  totalWorkedDays: string
  missingProcedureCodes: string
  unassnProcedures: string
  schedulesWoCode: string
}

export interface SchedulingPerformanceOverviewResult {
  period: DashboardPeriod
  periodStart: string
  periodEnd: string
  kpis: SchedulingPerformanceKpis
}

export interface SchedulingPerformanceChartPoint {
  label: string
  value: number
  isCurrent?: boolean
}

export interface SchedulingPerformanceChartConfig {
  data: SchedulingPerformanceChartPoint[]
  yDomain: [number, number]
  yTicks: number[]
}

export interface SchedulingPerformancePipelineRow {
  id: string
  provider: string
  datePeriod: string
  avgTimePatient: string
  utilization: string
  txOpportunities: string
}

export interface SchedulingPerformanceDetailResult {
  period: DashboardPeriod
  periodStart: string
  periodEnd: string
  kpis: SchedulingPerformanceKpis
  volumeChart: SchedulingPerformanceChartConfig
  utilizationChart: SchedulingPerformanceChartConfig
  pipeline: SchedulingPerformancePipelineRow[]
}

const schedulingPerformanceGet = <T>(
  path: string,
  params: SchedulingPerformanceQueryParams,
  options?: { signal?: AbortSignal },
): Promise<T> =>
  axios
    .get<
      ApiResponse<T>
    >(`${BUSINESS_LAYER_API}/api/v1/dashboard/scheduling/performance/${path}`, { params, signal: options?.signal })
    .then((response) => response.data.data)

export const getSchedulingPerformanceOverview = (
  params: SchedulingPerformanceQueryParams,
  options?: { signal?: AbortSignal },
): Promise<SchedulingPerformanceOverviewResult> =>
  schedulingPerformanceGet('overview', params, options)

export const getSchedulingPerformanceDetail = (
  params: SchedulingPerformanceQueryParams,
  options?: { signal?: AbortSignal },
): Promise<SchedulingPerformanceDetailResult> =>
  schedulingPerformanceGet('detail', params, options)
